export default {
  client_equip_details_revision_history_title: "Historial de Revisiones",
  client_equipaments_title: "Mis Equipos",
  client_home_quote_service_card: "Cotizar un Servicio",
  client_home_my_quotations_card: "Estado de los Servicios",
  client_home_my_equipments_card: "Mis Equipos",
  client_quotations_page_title: "Estado de los Servicios",
  client_quotations_home_breadcrumb: "Inicio",
  client_quotations_new_quote_btn: "Nueva Cotización",
  client_quotations_pending_section: "Esperando Mi Acción",
  client_quotations_processing_section: "Bepi Service",
  client_quotations_finished_section: "Finalizadas",
  client_quotations_no_quotations: "No hay cotizaciones en esta categoría.",
  client_quotations_view_details_btn: "Ver Detalles",
  client_quote_page_title: "Nueva Estimación",
  client_quote_home_breadcrumb: "Inicio",
  client_quote_quote_breadcrumb: "Cotizar un Servicio",
  client_quote_search_title: "¿Para qué equipo busca servicio?",
  client_quote_search_placeholder: "Eslinga",
  client_quote_search_empty_result: "No se encontro ningun servicio para la busqueda informada.",
  client_quote_success_saving_quote_msg: "¡Cotización enviada con éxito!",
  client_quote_cart_delete_title: "¿Eliminar ítem?",
  client_quote_cart_delete_warning: "Esta acción no se puede deshacer.",
  client_quote_cart_delete_confirm: "Sí, eliminar",
  client_quote_cart_oficina_title: "Mantenimiento en Taller",
  client_quote_cart_empresa_title: "Mantenimiento en Empresa",
  client_quote_cart_item_singular: "ítem",
  client_quote_cart_item_plural: "ítems",
  client_quote_cart_in_oficina_chip: "En nuestro taller",
  client_quote_cart_in_client_chip: "En el cliente",
  client_quote_cart_address_label: "Dirección de mantenimiento:",
  client_quote_cart_qty_label: "Cant: ",
  client_quote_cart_model_label: "Modelo: ",
  client_quote_cart_brand_label: "Marca: ",
  client_quote_cart_problem_label: "Problema: ",
  client_quote_cart_tasks_label: "Tareas: ",
  client_quote_cart_multiple_addresses_title: "Atención: Múltiples direcciones",
  client_quote_cart_multiple_addresses_text: "Tiene ítems para #vr0# direcciones diferentes. Cada dirección se considerará una visita separada.",
  client_quote_cart_page_title: "Presupuesto Estimado",
  client_quote_cart_home_breadcrumb: "Inicio",
  client_quote_cart_quote_breadcrumb: "Cotizar un Servicio",
  client_quote_cart_empty_title: "Ningún ítem agregado aún",
  client_quote_cart_empty_subtitle: "Agregue servicios para crear una cotización",
  client_quote_cart_add_first_btn: "Agregar Primer Ítem",
  client_quote_cart_total_label: "Total: ",
  client_quote_cart_in_oficina_suffix: "  #vr0# en el taller",
  client_quote_cart_addresses_suffix: " ⬢ #vr0# #vr1# de empresa",
  client_quote_cart_address_singular: "dirección",
  client_quote_cart_address_plural: "direcciones",
  client_quote_cart_add_new_btn: "Agregar Nuevo Ítem",
  client_quote_cart_request_quotes_btn: "Solicitar Cotizaciones",
  client_quote_modal_invalid_qty: "Cantidad inválida",
  client_quote_modal_model_required: "El modelo es obligatorio",
  client_quote_modal_brand_required: "La marca es obligatoria",
  client_quote_modal_problem_required: "El problema es obligatorio",
  client_quote_modal_location_required: "Seleccione el lugar de mantenimiento",
  client_quote_modal_address_required: "La dirección es obligatoria para mantenimiento en la empresa",
  client_quote_modal_edit_title: "Editando: ",
  client_quote_modal_add_title: "Cotizando: ",
  client_quote_modal_default_service: "Servicio",
  client_quote_modal_add_to_quote_btn: "Agregar a la Cotización",
  client_quote_modal_problem_label: "Problema o necesidad",
  client_quote_modal_problem_placeholder: "Describa detalladamente el problema o necesidad",
  client_quote_modal_location_label: "Lugar de Mantenimiento",
  client_quote_modal_in_oficina_radio: "Taller (Service)",
  client_quote_modal_in_empresa_radio: "InCompany (En mi empresa)",
  client_quote_modal_address_label: "Dirección de la empresa",
  client_quote_modal_address_placeholder: "Informe la dirección completa donde se realizará el mantenimiento",
  client_quote_modal_tasks_label: "Tareas adicionales (opcional)",
  client_quote_modal_obs_edit_label: "Observaciones",
  client_quote_modal_obs_auto_label: "Observaciones geradas automáticamente",
  client_quote_modal_obs_helper: "Estas observaciones se incluirán en la cotización",
  client_quote_search_cart_btn: "Carrito (#vr0#)",
  client_quote_details_id_error: "Tipo o ID no encontrado en la URL",
  client_quote_details_load_error: "Error al cargar detalles de la cotización",
  client_quote_details_num_label: "N° Estimación:",
  client_quote_details_location_label: "Lugar:",
  client_quote_details_items_label: "Ítems:",
  client_quote_details_value_label: "Valor:",
  client_quote_details_page_title: "Detalles de la Cotización",
  client_quote_details_loading: "Cargando detalles...",
  client_quote_details_step_summary: "Resumen de la Estimación",
  client_quote_details_step_shipping: "Orientación de Envío",
  client_quote_details_step_invoices: "Adjuntar Notas de Remesa",
  client_quote_details_step_checkout: "Checkout",
  client_quote_details_shipping_title: "Siga las orientaciones antes de enviar los equipos.",
  client_quote_details_shipping_reference_title: "Instrucciones de Envío",
  client_quote_details_shipping_reference_hint: "Haga clic en el botón para ver las instrucciones completas de envío del equipo.",
  client_quote_details_shipping_open_page_btn: "Abrir Orientaciones Completas",
  client_quote_details_shipping_review_checkbox: "Leí y comprendí las orientaciones de envío",
  client_quote_details_invoices_title: "Adjunte notas de remesa para liberar el checkout.",
  client_quote_details_checkout_hint: "Revise la información final y complete el flujo de la cotización.",
  client_quote_details_checkout_invoice_count: "Notas adjuntas:",
  client_quote_details_checkout_accept_estimate: "Aceptar Estimación",
  client_quote_details_checkout_refuse_estimate: "Rechazar Estimación",
  client_quote_details_checkout_accept_budget: "Aprobar Presupuesto",
  client_quote_details_checkout_refuse_budget: "Rechazar Presupuesto",
  client_quote_details_validation_summary: "Resumen de estimación inválido para avanzar.",
  client_quote_details_validation_shipping: "Confirme la lectura de orientaciones para avanzar.",
  client_quote_details_validation_invoices: "Adjunte al menos una nota de remesa para avanzar.",
  client_quote_details_validation_checkout_unavailable: "Aún no hay una acción de checkout disponible para esta cotización.",
  client_quote_details_validation_generic: "No fue posible avanzar al siguiente paso.",
  client_quote_details_refuse_reason_text: "Informe el motivo del rechazo:",
  client_quote_details_refuse_reason_placeholder: "Escriba el motivo del rechazo...",
  client_quote_details_refuse_reason_required: "Por favor, informe el motivo del rechazo",
  client_quote_details_refuse_confirm_btn: "Confirmar rechazo",
  client_quote_details_refuse_error: "No fue posible rechazar la estimación.",
  client_quote_details_budget_accept_title: "Aprobar presupuesto",
  client_quote_details_budget_accept_text: "¿Desea aprobar este presupuesto?",
  client_quote_details_budget_accept_confirm: "Aprobar",
  client_quote_details_budget_accept_error: "No fue posible aprobar el presupuesto.",
  client_quote_details_budget_refuse_title: "Rechazar presupuesto",
  client_quote_details_budget_refuse_error: "No fue posible rechazar el presupuesto.",
  client_shipment_title: "Instrucciones de Envio",
  client_shipment_important_warning: "Importante: Si es posible imprima y adjunte este documento junto al equipo. Si no puede imprimir, escriba el número de la cotización y su CNPJ/CIF en el embalaje de forma visible.",
  client_shipment_quote_data_title: "Datos de la Cotización",
  client_shipment_estimate_num_label: "Estimación nº: ",
  client_shipment_cnpj_label: "CNPJ/CIF: ",
  client_shipment_sender_title: "Remitente",
  client_shipment_client_label: "Cliente:",
  client_shipment_invoice_data_title: "Datos para emisión de factura",
  client_shipment_ie_label: "I.E:",
  client_shipment_company_name_label: "Razón Social:",
  client_shipment_address_label: "Dirección:",
  client_shipment_procedure_title: "Procedimiento para emitir la Factura de Envío para Reparación",
  client_shipment_procedure_step1: "Emitir una factura de \"Envío para Reparación\" CFOP 5915 (estado de SP) o CFOP 6915 (otros estados).",
  client_shipment_procedure_step2: "Enviar la copia de la Factura al correo: fiscal@bunzl.com.br para que liberemos el envío de los equipos.",
  client_shipment_procedure_step3: "Recordando que el envío y retiro de los equipos en nuestra unidad son responsabilidad de la empresa contratante del servicio.",
  client_shipment_sedex_warning: "La aceptacion del envio via SEDEX exime a BUNZL de cualquier responsabilidad por perdida de material. La responsabilidad del envio recae en el contratante y en el Servicio Postal.",
  client_shipment_certificate_hint: "El equipo se devolvera con Certificado de Calibracion/Ajuste, acompanado de las correspondientes Facturas.",
  client_shipment_important_title: "Importante",
  client_shipment_shipping_costs_warning: "Los gastos de envío y devolución no están incluidos y son responsabilidad del contratante.",
  client_shipment_refusal_right_warning: "Nos reservamos el derecho de rechazar el servicio si, tras el examen, el Centro Técnico verifica que el equipo está en condiciones irreparables o con daños excesivos.",
  client_shipment_incorrect_nf_warning: "En caso de envío con Factura incorrecta, el equipo se devolverá a la dirección informada en la factura con flete FOB.",
  client_shipment_doubts_help: "En caso de dudas, póngase en contacto con nuestro servicio de atención al cliente.",
  client_shipment_home_btn: "Volver al Inicio",
  client_shipment_print_btn: "Imprimir Instrucciones",
  client_equip_details_download_error: "Equipo detalles descargar error.",
  client_equip_details_id_not_found: "ID del equipo no encontrado",
  client_equip_details_item_data_title: "Datos del Equipo",
  client_equip_details_latest_photos_title: "Últimas Fotos del Equipo",
  client_equip_details_not_found: "Equipo no encontrado",
  client_equipaments_no_equipment_found: "Equipos sin equipo encontrado",
  client_equipaments_quote_pending_btn: "Cotizar Pendientes",
  client_home_welcome_question: "¿Qué deseas hacer?",
  client_quotations_error_loading: "Error al cargar cotizaciones.",
  client_quotations_filter_all_products: "Todos los productos",
  client_quotations_filter_product_label: "Filtrar por producto",
  client_quotations_refresh_btn: "Actualizar",
  client_quotations_table_product: "Producto",
  client_quotations_view_kanban: "Kanban",
  client_quotations_view_list: "Lista",
  client_quote_catalog_error: "Error al cargar el catálogo de servicios.",
  client_quote_empty_error: "La cotización está vacía. Agregue ítems antes de enviar.",
  client_quote_equipments_error: "Error al cargar equipos.",
  client_quote_send_error: "Error al enviar cotización. Intente nuevamente.",
  client_help_modal_title: "Guia",
  client_help_modal_not_available: "No hay ayuda disponible para esta pantalla.",
  client_help_view_client_home_title: "Inicio",
  client_help_view_client_home_intro: "Estas en la pantalla inicial. Estas son las acciones principales:",
  client_help_view_client_home_item_quote: "Solicitar una cotizacion de servicio.",
  client_help_view_client_home_item_quotations: "Acompanhar el estado de tus cotizaciones.",
  client_help_view_client_home_item_equipments: "Gestionar tus equipos.",
  client_help_view_client_quotation_title: "Estado de los servicios",
  client_help_view_client_quotation_intro: "En esta pantalla puedes seguir tus cotizaciones por secciones y tipos de tarjeta.",
  client_help_view_client_quotation_sections_heading: "Secciones",
  client_help_view_client_quotation_section_waiting: "Esperando mi accion: casos que requieren tu accion.",
  client_help_view_client_quotation_section_in_progress: "Bepi Service: casos en proceso de ejecucion.",
  client_help_view_client_quotation_section_finished: "Finalizados: casos ya concluidos.",
  client_help_view_client_quotation_cards_heading: "Tipos de tarjeta",
  client_help_view_client_quotation_card_estimate: "Estimacion: propuesta con valor estimado del servicio.",
  client_help_view_client_quotation_card_budget: "Presupuesto: propuesta con valor final del servicio.",
  client_help_view_client_quotation_card_order: "Pedido: presupuesto aprobado y en ejecucion.",
  client_help_view_client_estimate_title: "Como solicitar cotizacion",
  client_help_view_client_estimate_intro: "Sigue este flujo para crear y enviar tu cotizacion:",
  client_help_view_client_estimate_step_1: "Elige el equipo que deseas cotizar.",
  client_help_view_client_estimate_step_2: "Completa los datos del item y agregalo al carrito.",
  client_help_view_client_estimate_step_3: "Define el lugar del servicio. Si es en tu empresa, informa la direccion completa.",
  client_help_view_client_estimate_closing: "Listo. Haz clic en Solicitar Cotizaciones para finalizar.",
  client_help_view_client_equipments_title: "Mis equipos",
  client_help_view_client_equipments_intro: "Aqui encuentras equipos que ya pasaron por mantenimiento.",
  client_help_view_client_equipments_item_history: "Ver historial de mantenimientos.",
  client_help_view_client_equipments_item_quote: "Solicitar nuevos servicios.",
  client_help_view_client_equipments_item_photos: "Ver fotos del equipo.",
  client_help_view_client_equipments_item_reports: "Descargar informes tecnicos.",
  client_help_view_client_details_title: "Detalles de la cotizacion",
  client_help_view_client_details_intro: "Esta pantalla muestra acciones disponibles para estimacion y presupuesto.",
  client_help_view_client_details_estimate: "Al recibir una estimacion, puedes aceptar o rechazar.",
  client_help_view_client_details_budget: "Para el presupuesto, tambien puedes aceptar o rechazar para seguir el flujo.",
  client_help_view_client_shipping_title: "Orientaciones de envio",
  client_help_view_client_shipping_intro: "Lee esta pagina con atencion antes de enviar el equipo.",
  client_help_view_client_equipment_details_title: "Detalles del equipo",
  client_help_view_client_equipment_details_intro: "Aqui encuentras informacion detallada sobre equipo y mantenimientos.",
  client_quotations_table_ref: "Ref.",
  client_quotations_table_value: "Valor",
  client_quotations_table_local: "Local",
  client_quotations_view_mode_label: "Visualizacion",
  client_quotations_view_mode_aria_label: "Modo de visualizacion de cotizaciones",
  client_quote_details_confirm_btn: "Confirmar",
  client_quote_details_ok_btn: "OK",
  client_quote_details_warning_title: "Atencion",
  client_quote_details_flow_lock_message: "Los siguientes pasos se habilitaran cuando se entregue la estimacion.",
  client_quote_details_estimate_accept_title: "Aceptar estimacion",
  client_quote_details_estimate_accept_text: "Confirma la aceptacion de la estimacion para continuar el flujo?",
  client_quote_details_estimate_accept_confirm: "Confirmar aceptacion",
  client_quote_details_estimate_accept_success_title: "Estimacion aceptada",
  client_quote_details_estimate_accept_success_text: "La aceptacion de la estimacion se registro con exito.",
  client_quote_details_estimate_accept_error: "No fue posible procesar la aceptacion de la estimacion.",
  client_quote_details_estimate_refuse_title: "Rechazar estimacion",
  client_quote_details_estimate_refuse_success_title: "Estimacion rechazada",
  client_quote_details_budget_refuse_success_title: "Presupuesto rechazado",
  client_quote_details_refusal_success_message: "El rechazo se registro con exito.",
  client_quote_details_budget_accept_success_title: "Presupuesto aprobado",
  client_quote_details_budget_accept_success_text: "Presupuesto aprobado con exito.",
  client_quote_details_quote_number_title: "Cotizacion #vr0#",
  client_quote_details_client_data_title: "Datos del Cliente",
  client_quote_details_client_contact_label: "Contacto",
  client_quote_details_client_phone_label: "Telefono",
  client_quote_details_client_email_label: "Correo",
  client_quote_details_estimate_data_title: "Datos de la Estimacion",
  client_quote_details_response_label: "Respuesta",
  client_quote_details_budget_deadline_label: "Plazo",
  client_quote_details_budget_validity_label: "Validez",
  client_quote_details_budget_notes_label: "Observaciones del tecnico",
  client_quote_details_business_days_suffix: "dias habiles",
  client_quote_details_item_fallback: "Item #vr0#",
  client_quote_details_qty_short_label: "Cant",
  client_quote_details_current_status_title: "Estado Actual de la Cotizacion",
  client_quote_details_no_status: "Sin estado",
  client_quote_details_budget_section_title: "Datos del Presupuesto",
  client_shipment_loading: "Cargando instrucciones de envio...",
  client_shipment_load_error: "Error al cargar instrucciones de envio.",
}

